// extracted by mini-css-extract-plugin
export default {"controlRow":"MGInput_controlRow__BBv8R","leftIcon":"MGInput_leftIcon__Bz3TF","rightIcon":"MGInput_rightIcon__u+TyD","rightIconButton":"MGInput_rightIconButton__RNSRm"};